import * as v from 'valibot';

import { maoAirportSchema } from './maoAirport.schema';

import type { MaoCrewDuty } from '../types';

export const maoCrewDutySchema: v.GenericSchema<MaoCrewDuty> = v.object({
  OnDutyDateTime: v.string('On duty datetime is missing'),
  OnDutyDateTimeUnix: v.number('On duty datetime unix is missing'),
  OffDutyDateTime: v.string('Off duty datetime is missing'),
  OffDutyDateTimeUnix: v.number('Off duty datetime unix is missing'),
  Crew: v.object({
    Id: v.number('Crew ID is missing'),
    Contact: v.object({
      FirstNames: v.string('Crew first names are missing'),
      LastName: v.string('Crew last name is missing'),
    }),
  }),
  Id: v.number('Crew duty ID is missing'),
  AircraftId: v.nullish(v.number('Invalid aircraft ID')),
  CrewId: v.number('Crew ID is missing'),
  // Aircraft?: MaoAircraft | null;
  StartAirport: maoAirportSchema,
  EndAirport: maoAirportSchema,
});
